import { HttpClient } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { map } from 'rxjs/operators';
import { createHttpParams } from '~/infrastructure/http/params';
import { augmentPaging } from '~/infrastructure/paging';
import { MobileAppGroupListing } from '~/models/administration/mobileAppGroup';
import { ApiServiceBase, API_NAMES } from '~/services/api';

@Injectable({ providedIn: 'root' })
export class MobileAppGroupsService extends ApiServiceBase {
    constructor(injector: Injector, private http: HttpClient) {
        super(injector);
        this.setBase(API_NAMES.adminStock);
    }

    getMobileAppGroup(id: number) {
        return this.http.get<MobileAppGroupListing>(this._url(`/${id}`));
    }

    getMobileAppGroupListing() {
        return this.http.get<MobileAppGroupListing[]>(this._url(`/groupslisting`));
    }

    getMobileAppGroups(paramsObj?: any, model?: any) {
        paramsObj = paramsObj || {};
        paramsObj.view = 'summary';
        let params = createHttpParams(paramsObj);

        return this.http
            .post<MobileAppGroupListing[]>(this._url(`/grid-data`), model, {
                params,
                observe: 'response',
            })
            .pipe(map(augmentPaging));
    }

    createMobileAppGroup(model: any) {
        return this.client.post<string>(this._url(), model);
    }

    updateMobileAppGroup(id: number, model: any) {
        return this.client.put(this._url(`/${id}`), model);
    }

    deleteMobileAppGroup(id: number) {
        return this.client.delete(this._url(`/${id}`));
    }

    private _url(v?: string | undefined) {
        v = v || '';
        return this.url(`/MobileAppGroups${v}`);
    }
}
